import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getContractProductInfoSlice = createSlice({
    name: "getContractProductInfo",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getContractProductInfoSlice_actions = getContractProductInfoSlice.actions;
export var fetchData = _getContractProductInfoSlice_actions.fetchData, fetchDataSuccess = _getContractProductInfoSlice_actions.fetchDataSuccess, fetchDataFailure = _getContractProductInfoSlice_actions.fetchDataFailure, resetState = _getContractProductInfoSlice_actions.resetState;
export default getContractProductInfoSlice.reducer;
